import { Type } from "@feathersjs/typebox";
export const fdpsFlightStatusList = [
    "ACTIVE",
    "DROPPED",
    "PROPOSED",
    "COMPLETED",
    "CANCELLED",
];
export const flightRules = ["IFR", "VFR", "SVFR", "DVFR"];
export function isFlightRule(s) {
    return flightRules.includes(s);
}
export const equipmentQualifiers = [
    "L",
    "G",
    "U",
    "Z",
    "A",
    "I",
    "W",
    "R",
    "Q",
    "S",
    "X",
    "Y",
];
export function isEquipmentQualifier(s) {
    return equipmentQualifiers.includes(s);
}
export const aircraftPerformanceCategories = ["A", "B", "C", "D", "E", "F"];
export function isAircraftPerformanceCategory(s) {
    return aircraftPerformanceCategories.includes(s);
}
export const wakeTurbCategories = ["M", "H", "L", "J"];
export function isWakeTurbCategory(s) {
    return wakeTurbCategories.includes(s);
}
export const NasAssignedAltitudeSchema = Type.Object({
    simple: Type.Optional(Type.Integer()),
    block: Type.Optional(Type.Object({
        min: Type.Integer(),
        max: Type.Integer(),
    })),
    above: Type.Optional(Type.Integer()),
    altFixAlt: Type.Optional(Type.Object({
        fix: Type.String(),
        post: Type.Integer(),
        pre: Type.Integer(),
    })),
    vfrOnTop: Type.Optional(Type.Boolean()),
    vfrPlus: Type.Optional(Type.Integer()),
    vfrOnTopPlus: Type.Optional(Type.Integer()),
    vfr: Type.Optional(Type.Boolean()),
}, { $id: "nasAssignedAltitude" });
export function formatAssignedAltitude(assignedAlt) {
    if (!assignedAlt)
        return "";
    if (assignedAlt.vfr)
        return "VFR";
    if (assignedAlt.vfrOnTop)
        return "OTP";
    if (assignedAlt.vfrPlus)
        return `VFR/${assignedAlt.vfrPlus}`;
    if (assignedAlt.vfrOnTopPlus)
        return `OTP/${assignedAlt.vfrOnTopPlus}`;
    if (assignedAlt.above)
        return `ABV/${assignedAlt.above}`;
    if (assignedAlt.simple !== undefined)
        return assignedAlt.simple.toString();
    if (assignedAlt.block) {
        return `${assignedAlt.block.min}B${assignedAlt.block.max}`;
    }
    if (assignedAlt.altFixAlt) {
        return `${assignedAlt.altFixAlt.pre}/${assignedAlt.altFixAlt.fix}${assignedAlt.altFixAlt.post}`;
    }
    return "";
}
export const etaTimeTypes = [
    "ACTUAL",
    "AIRLINE",
    "EARLY_INTENT",
    "ESTIMATED",
    "METERED",
    "PROPOSED",
    "REROUTE",
    "SCHEDULED",
    "TAXIED",
];
export const etdTimeTypes = [
    "ACTUAL",
    "AIRLINE",
    "CONTROLLED",
    "ESTIMATED",
    "PROPOSED",
    "SCHEDULED",
];
//# sourceMappingURL=nasTypes.js.map